import { Injectable } from "@angular/core"
import { AngularFireAuth } from "@angular/fire/compat/auth"
import { BehaviorSubject, Observable } from "rxjs"
import { AngularFireDatabase } from "@angular/fire/compat/database"

import { environment } from "../../environments/environment"
import { HttpClient } from "@angular/common/http"
import { LanguageService } from "./language.service"
import { AlertController } from "@ionic/angular"
import { AuthService } from "./auth.service"
import { PosUser } from "./settings.service"


@Injectable({ providedIn: "root" })
export class UserService {
    user$ = new Observable<User>();
    user = new BehaviorSubject<User>({} as User)
    selectedUnit: Unit
    headerShown = new BehaviorSubject<boolean>(true);
    public availableUnits: any[] = [];
    public selectedUnit$ = new BehaviorSubject<Unit>({} as Unit)
    public selectedOrganisation$ = new BehaviorSubject<any>(null)
    public selectedUnit2$ = new BehaviorSubject<Unit | null>(null)
    userClientGroupId = ""
    hideSidebar = false
    selectedUnitObs = new BehaviorSubject<Unit>(undefined);
    posUserList: PosUser[];
    usePosUsers: boolean = false;
    selectedPosUser = new BehaviorSubject<PosUser>(undefined);
    constructor(
        private afAuth: AngularFireAuth,
        private afDatabase: AngularFireDatabase,
        private http: HttpClient,
        private languageProvider: LanguageService,
        private alertController: AlertController
    ) {

        this.user$ = this.user.asObservable()
        this.afAuth.user.subscribe(async (x) => {
            if (!x) this.user.next({} as User)
            else {
                let token = await x.getIdToken();
                try {
                    let languageCode = await this.getLanguage(x.uid)
                    this.languageProvider.setLanguage(
                        languageCode ? languageCode : "en"
                    )

                    this.user.next({
                        email: x.email ? x.email : "",
                        id: x.uid,
                        name: x.displayName ? x.displayName : "",
                        units: [],
                        languageCode: languageCode ? languageCode : "en",
                        token: token
                    })
                } catch (error) {
                    console.error(error)
                    this.user.next({
                        email: x.email ? x.email : "",
                        id: x.uid,
                        name: x.displayName ? x.displayName : "",
                        units: [],
                        languageCode: "en",
                        token: token
                    })
                }
            }
        })
        this.selectedUnit$.subscribe((x) => {
            this.selectedUnit = x
        })
    }

    async getUserGroups(routeName, userId) {
        let body = {
            userId,
            routeName,
        }
        try {
            // let result = await this.http
            //     .post<any>(
            //         `${environment.pubQueueApiUrl}/api/v1/userGroupsForUserId`,
            //         body
            //     )
            //     .toPromise()
            let result = await this.http
                .post<any>(
                    `${environment.pubQueueApiUrlEU}/v1/usergroups/users/${userId}`,
                    body
                )
                .toPromise()
            return result
        } catch (err) {
            console.dir(err)
            return null
        }
    }

    async getPurchaseHistoryItem(userId: string, key: string): Promise<any> {
        let receipt = await this.afDatabase.database
            .ref(`usersPurchaseHistory_v2/${userId}/${key}`)
            .once("value")
        return receipt.val()
    }

    async getUnits(userId: string) {
        return this.afDatabase
            .object<ClientGroup>(`usersAdminApp/${userId}/clientGroups/0`)
            .query.once("value")
            .then((snapshot) => {
                var clientGroup = snapshot.val()
                this.userClientGroupId = clientGroup.id
                return clientGroup.units
            })
    }
    async getLanguage(userId: string) {
        return window.localStorage.getItem("PUBQ_DASHBOARD_LANGUAGECODE");

        // return this.afDatabase
        //     .object<string>(`usersAdminApp/${userId}/languageCode`)
        //     .query.once("value")
        //     .then((snapshot) => {
        //         var languageCode = snapshot.val()
        //         return languageCode
        //     })
    }
    updateUnit(unit: Unit) {
        var index = this.user.value.units.indexOf(unit)
        return this.afDatabase
            .object<Unit>(
                `usersAdminApp/${this.user.value.id}/clientGroups/0/units/${index}`
            )
            .update({
                info: unit.info,
            })
    }
    updateLanguage(languageCode: string) {
        this.afDatabase
            .object<string>(`usersAdminApp/${this.user.value.id}/languageCode`)
            .set(languageCode)
    }

    signOut() {
        return this.afAuth.signOut()
    }


    async showUnitsSelectAlert(units: any[]) {
        let selectedUnit = this.selectedUnit$.value;
        let inputs = []
        units.forEach((x) => {
            if (x.routeName === selectedUnit.routeName) return;
            inputs.push({
                name: x.routeName,
                type: "checkbox",
                label: x.name,
                value: x,
                checked: false,
            })
        })
        const alertCheck = await this.alertController.create({
            header: "Välj enheter",
            cssClass: "large-alert",
            backdropDismiss: false,
            inputs: inputs,
            buttons: [
                {
                    text: "Avbryt",
                    role: "cancel",
                    cssClass: "secondary",
                    handler: () => {
                        console.log("Confirm Cancel")
                    },
                },
                {
                    text: "Ok",
                    role: "confirm",
                    handler: (a) => {
                        console.log("Confirm Ok")
                    },
                },
            ],
        })
        await alertCheck.present()
        let result = await alertCheck.onDidDismiss()
        if (result.role === "confirm") return result.data.values
        return []
    }


    async searchUser(value: string, type: string) {
        let data = {
            authType: type,
            searchValue: value,
        }
        try {
            let result = await this.http
                .post<any>(`${environment.pubQueueApiUrlEU}/v1/units/users/search`, data)
                .toPromise()


            return result;
        } catch (error) {
            throw error
        }
    }
    async getUserData(userId): Promise<any[]> {
        if (!userId) return [];
        let response = await this.http
            .post<any[]>(
                `${environment.pubQueueApiUrlEU}/v1/users/retrieve`,
                { userId }
            )
            .toPromise()
        return response ? response : [];
    }
    async getUnitsForOrg(userId, organisationId): Promise<any[]> {
        let response = await this.http
            .post<any[]>(
                `${environment.pubQueueApiUrlEU}/v1/organisation/units/retrieve`,
                { userId, organisationId }
            )
            .toPromise();

        this.availableUnits = response ? response : [];
        return this.availableUnits;
    }
    async getCompaniesForOrg(userId, organisationId): Promise<any[]> {
        let response = await this.http
            .post<any[]>(
                `${environment.pubQueueApiUrlEU}/v1/organisation/companies/retrieve`,
                { userId, organisationId }
            )
            .toPromise()
        return response ? response : []
    }
    async completeRegistration(data: any): Promise<any> {
        let response = await this.http
            .post<any[]>(
                `${environment.pubQueueApiUrlEU}/v1/users/signup/completed`,
                data
            )
            .toPromise()
        return response
    }

    //   Welcome Email
    async sendWelcomeEmail(userEmail: string) {
        const endpoint = `${environment.pubQueueApiUrl}/dashboard/v1`
        const body = {
            email: userEmail
        }
        return this.http.post(endpoint + "/email/welcome", body).toPromise()
    }
    async createNewUser(data: any) {
        const endpoint = `${environment.pubQueueApiUrlEU}/v1`
        return this.http.post(endpoint + "/users/createnew", data).toPromise()
    }

    getPosUserById(id) {
        if (!id) return undefined;
        if (this.posUserList) {
            let user = this.posUserList.find(x => x.id == id);
            return user;
        }
        return undefined;
    }
    async getUsePosLogin(): Promise<boolean> {
        let useUsersRef = this.afDatabase.database.ref(
            `adminApp/clients/${this.selectedUnit.routeName}/settings/pos/useUsers`
        );
        this.usePosUsers = (await useUsersRef.once("value")).val();
        return this.usePosUsers;
    }

    // Update whitelabel user info from Guest Information module.
    async updateGuestInfo(data) {
        try {
            let result = await this.http
                .post<any>(`${environment.pubQueueApiUrlEU}/v1/units/users/updateGuestInfo`, data)
                .toPromise()
            return result
        } catch (err) {
            return err;
        }
    }
}
export class User {
    name: string
    id: string
    email: string
    units: Unit[]
    languageCode: string
    token: string
}
export class Unit {
    id: string;
    routeName: string
    info: UnitInfo
    franchiseId?: string
    name: string;
}
export class UnitInfo {
    restaurantId?: string
    name: string
    orgNo: string
    address: string
    zipCode: string
    city: string
    logoUrl: string
    blurHash?: string
    companyName: string;
    phoneNumber: string;
    email: string;
}
export class ClientGroup {
    id: string
    units: Unit[]
}
